module.exports = __webpack_public_path__ + "img/mop_905020_r2@2x.2544ea3c.png";